module.exports = __webpack_public_path__ + "img/banner-1.5f868a3a.jpg";